// extracted by mini-css-extract-plugin
export default {"maitanance_time__module":"x9wZc","fixed":"HcnnY","maitanance_time":"Crty3","maitanance_time_text":"uM5Tt","marquee":"GZo04","maitanance_time_icon":"ZcehN"};